__turbopack_context__.v({
  "blocksBackgroundColor": "NewsSelector-module-scss-module__jLLO8a__blocksBackgroundColor",
  "blocksFontColor": "NewsSelector-module-scss-module__jLLO8a__blocksFontColor",
  "dateContainer": "NewsSelector-module-scss-module__jLLO8a__dateContainer",
  "expandedView": "NewsSelector-module-scss-module__jLLO8a__expandedView",
  "leftPaneContainer": "NewsSelector-module-scss-module__jLLO8a__leftPaneContainer",
  "leftPaneTransitionContainer": "NewsSelector-module-scss-module__jLLO8a__leftPaneTransitionContainer",
  "lineClamp": "NewsSelector-module-scss-module__jLLO8a__lineClamp",
  "newsItem": "NewsSelector-module-scss-module__jLLO8a__newsItem",
  "newsItemInfo": "NewsSelector-module-scss-module__jLLO8a__newsItemInfo",
  "newsItemScroll": "NewsSelector-module-scss-module__jLLO8a__newsItemScroll",
  "newsItemScrollbarTerrace": "NewsSelector-module-scss-module__jLLO8a__newsItemScrollbarTerrace",
  "newsItemSelected": "NewsSelector-module-scss-module__jLLO8a__newsItemSelected",
  "newsSelectorContainer": "NewsSelector-module-scss-module__jLLO8a__newsSelectorContainer",
  "rightPaneContainer": "NewsSelector-module-scss-module__jLLO8a__rightPaneContainer",
  "rightPaneTransitionContainer": "NewsSelector-module-scss-module__jLLO8a__rightPaneTransitionContainer",
  "rightPaneTransitionContainerHideLeftColumn": "NewsSelector-module-scss-module__jLLO8a__rightPaneTransitionContainerHideLeftColumn",
  "schoolFeedList": "NewsSelector-module-scss-module__jLLO8a__schoolFeedList",
  "scrollBarStyle": "NewsSelector-module-scss-module__jLLO8a__scrollBarStyle",
  "secondaryNavBackgroundColor": "NewsSelector-module-scss-module__jLLO8a__secondaryNavBackgroundColor",
  "themeBackgroundColor": "NewsSelector-module-scss-module__jLLO8a__themeBackgroundColor",
  "themeFontColor": "NewsSelector-module-scss-module__jLLO8a__themeFontColor",
  "transitionAppear": "NewsSelector-module-scss-module__jLLO8a__transitionAppear",
  "transitionAppearActive": "NewsSelector-module-scss-module__jLLO8a__transitionAppearActive",
  "transitionAppearDone": "NewsSelector-module-scss-module__jLLO8a__transitionAppearDone",
  "transitionEnter": "NewsSelector-module-scss-module__jLLO8a__transitionEnter",
  "transitionEnterActive": "NewsSelector-module-scss-module__jLLO8a__transitionEnterActive",
  "transitionEnterDone": "NewsSelector-module-scss-module__jLLO8a__transitionEnterDone",
  "transitionExit": "NewsSelector-module-scss-module__jLLO8a__transitionExit",
  "transitionExitActive": "NewsSelector-module-scss-module__jLLO8a__transitionExitActive",
  "transitionExitDone": "NewsSelector-module-scss-module__jLLO8a__transitionExitDone",
  "viewMoreButton": "NewsSelector-module-scss-module__jLLO8a__viewMoreButton",
});
